import React, { useEffect, useState } from 'react';
import { ModalOverlay } from '../../../components/MyPage/StyledComponents';
import styled from 'styled-components';
const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

export const TaxInvoice = ({onClose}) => {
  return ( <>  <Overlay onClick={onClose} />
    <ModalContainer>
    <div style={{ width: '800px', border: '1px solid #000', padding: '10px', fontSize: '12px', lineHeight: '1.5' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>계산서 (공급받는자 보관용)</h2>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <div>
          <div>등록번호: 523-81-03358</div>
          <div>상호(법인명): (주)언체인</div>
          <div>성명: 박준영</div>
          <div>주소: 경기도 남양주시 순화궁로 249, M동 13층 1330호(별내동, 별내역파라곤스퀘어)</div>
          <div>업태: 정보통신업 , 도소매업</div>
          <div>종목:소프트웨어 및 솔루션 개발 전자상거래</div>
        </div>
        <div>
          <div style={{ border: '1px solid #000', width: '100px', height: '100px', textAlign: 'center' }}>공급자 도장</div>
        </div>
      </div>
      <div style={{ marginBottom: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>작성일자: 2000년 01월 01일</div>
          <div>공급가액: 0원</div>
        </div>
      </div>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <thead>
          <tr>
            <th style={{ border: '1px solid #000', padding: '5px' }}>월일</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>품목</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>규격</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>수량</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>단가</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>공급가액</th>
            <th style={{ border: '1px solid #000', padding: '5px' }}>비고</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px' }}>yyyy-mm-dd</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>영화표</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}></td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>1</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>0</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>0</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}></td>
          </tr>
        </tbody>
      </table>
      <div style={{ textAlign: 'right' }}>합계금액: 0원</div>
      <div style={{ textAlign: 'right', marginTop: '10px' }}>현금 □ 수표 □ 어음 □ 외상미수금 √</div>
      <div style={{ marginTop: '20px', textAlign: 'center' }}>위 금액을 영수 함</div>
    </div>
    </ModalContainer>
    </>
  );
};

export default TaxInvoice;